import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

enum DigitType
{
  RegularDigit,
  BigDigit,
  SmallDigit
}
@Component({
  selector: 'formatted-price',
  template: require('./formatted-price.component.html'),
  styles: [require('./formatted-price.component.css')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormattedPriceComponent implements OnInit {

  @Input()
  baseFontSize = 20;

  @Input()
  bigDigitFactor = 1.583333;

  @Input()
  smallDigitFactor = 0.631578;

  @Input()
  bigDigitsEnabled = true;

  @Input()
  smallDigitsEnabled = true;

  @Input()
  bigDigitBold = true;

  @Input()
  smallDigitMargin = 0;

  @Input()
  price: number = 123.4567;

  get bigDigitFontSize()
  {
    return this.bigDigitsEnabled? this.baseFontSize * this.bigDigitFactor: this.baseFontSize;
  }

  get smallDigitFontSize()
  {
    return this.smallDigitsEnabled? this.bigDigitFontSize*this.smallDigitFactor: this.baseFontSize;
  }

  get priceCharArray(): string[]
  {
    return this.price.toString().split('');
  }

  constructor() { }

  ngOnInit() {
  }

  getDigitType(i: number, char: string)
  {
    if((i == this.priceCharArray.length - 4 && this.priceCharArray[i+1] == '.') || (i == this.priceCharArray.length - 3 && char != '.') || (i == this.priceCharArray.length - 4 && this.priceCharArray[this.priceCharArray.length-2] == '.') || (i == this.priceCharArray.length - 2 && char != '.'))
      return DigitType.BigDigit;
    
    if(i == this.priceCharArray.length - 1)
      return DigitType.SmallDigit;

    return DigitType.RegularDigit;
  }


  getFontSizeByDigitType(digitType: DigitType)
  {
    if(digitType == DigitType.BigDigit)
      return this.bigDigitFontSize;

    if(digitType == DigitType.SmallDigit)
      return this.smallDigitFontSize

    return this.baseFontSize;
  }

  getTopByDigitType(digitType: DigitType)
  {
    if(this.smallDigitsEnabled && digitType == DigitType.SmallDigit)
      return (-0.2631*this.bigDigitFontSize)+((this.smallDigitFactor-0.631578)*7.4996);//3.746553);
    
    return 0;
  }

  getFontWeightByDigitType(digitType: DigitType)
  {
    if(this.bigDigitBold && digitType == DigitType.BigDigit)
      return 400
    
    return undefined;
  }

  getMarginLeftByDigitType(digitType: DigitType)
  {
    if(digitType == DigitType.SmallDigit)
      return this.smallDigitMargin;
    
    return undefined;
  }

  getFontSize(i: number, char: string)
  {
    return this.getFontSizeByDigitType(this.getDigitType(i, char));
  }

  getTop(i: number, char: string)
  {
    return this.getTopByDigitType(this.getDigitType(i, char));
  }

  getFontWeight(i: number, char: string)
  {
    return this.getFontSizeByDigitType(this.getDigitType(i, char));
  }

  getMarginLeft(i: number, char: string)
  {
    return this.getMarginLeftByDigitType(this.getDigitType(i, char));
  }
}
